import requestor from "../../requestor";

export default class TarifficationApi {
  service = {
    all: () => requestor.get("/tariff-service/service_all"),
    cancelRecurring: (recurringId) =>
      requestor.patch("/tariff-service/cancel_recurring", { recurring_id: recurringId }),
    options: {
      all: (serviceTypeId) =>
        requestor.get("/tariff-service/service_options_all", {
          service_type_id: serviceTypeId,
        }),
    },
    create: (serviceTypePeriodPriceId, projectId, isRecurring) =>
      requestor.post("/tariff-service/service_create", {
        service_type_period_price_id: serviceTypePeriodPriceId,
        selected_project: projectId,
        is_recurring: isRecurring,
      }),
    getTarrifData: (service_instance_id) =>
      requestor.post("/tariff-service/service-upgrade-options-all", {
        service_instance_id,
      }),
    upgradeTariff: (service_instance_id, period_paid, is_recurring) =>
      requestor.post("/tariff-service/service-upgrade", {
        service_instance_id,
        period_paid,
        is_recurring,
      }),

    prolongation: {
      options: {
        all: (serviceInstanceId) =>
          requestor.get("/tariff-service/service_prolongation_options_all", {
            service_instance_id: serviceInstanceId,
          }),
      },
      prolongate: (serviceInstanceId, periodPaid, isRecurring) =>
        requestor.post("/tariff-service/service_prolongate", {
          service_instance_id: serviceInstanceId,
          period_paid: periodPaid,
          is_recurring: isRecurring,
        }),
    },
  };

  project = {
    create: () => requestor.post("/tariff-service/project_create"),
  };

  invoice = {
    all: () => requestor.get("/tariff-service/invoice_all"),
    document: {
      generate: (invoiceId) => requestor.get("/tariff-service/generate_invoice_document", { invoice_id: invoiceId }),
    },
    getPayParams: (invoiceId) => requestor.get("/tariff-service/pay-params", { invoice_id: invoiceId }),
  };
}
